import { Injectable } from '@angular/core';
import { CcmSessionData } from '@fi-app/components/core-base';
import {
    ITakePictureData,
    MobileAppHelperBaseService,
} from '@fi-shared/fi-shared-services/mobile-app-helper-base.service';
import { FiApplicationLanguageType } from '@fi-shared/fi-content-language-shared/fi-application-language-type';
import { IObjectDto } from '@fi-shared/models/models';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { eventFindInPath } from '@fi-shared/utils';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';

@Injectable()
export class FiMobileAppHelperService extends MobileAppHelperBaseService {
    constructor(
        private userDataService: FiUserDataService,
        private fiStateService: FiStateService,
    ) {
        super();
    }

    isWebsite = true;
    private mobileAppTokenKey = 'fi-mobileAppModeToken';
    private _mobileAppMode = false;
    get mobileAppMode() {
        return this._mobileAppMode || localStorage.getItem(this.mobileAppTokenKey) === this.userDataService.getToken();
    }

    isMobileAppIos() {
        return false;
    }

    closeIFrame() {
        this.postMessage('fic.CloseIFrame');
    }

    reloadPriorityFeed() {
        this.postMessage('fic.ReloadPriorityFeed');
    }

    openExternalLink(url: string) {
        this.postMessage('fic.OpenExternalLink', { url: url });
    }

    openUpdateAppLink() {
        const url =
            window.cordova && window.cordova.platformId === 'ios'
                ? 'https://apps.apple.com/se/app/chainformation-companion/id1434543854'
                : 'https://play.google.com/store/apps/details?id=com.chainformation.companion';
        window.open(url, '_system');
        //this.postMessage('fic.OpenUpdateAppLink');
    }

    downloadFile(url: string, fileName: string, contentType?: string) {
        this.postMessage('fic.DownloadFile', {
            url: encodeURI(url),
            fileName: fileName,
            contentType: contentType,
        });
        return Promise.resolve();
    }

    canCloseAppIFrame(key) {
        this.postMessage('fic.CanCloseAppIFrame', { key: key });
    }

    takePicture(callback) {
        this.postMessage('fic.TakePicture', { callback: callback });
        return new Promise<ITakePictureData>((resolve, reject) => {});
    }

    scanQRCode(callback) {
        this.postMessage('fic.ScanQRCode', { callback: callback });
    }

    showGlobalScanner() {
        this.postMessage('fic.ToggleGlobalQRScanner', { visible: true });
    }

    hideGlobalScanner() {
        this.postMessage('fic.ToggleGlobalQRScanner', { visible: false });
    }

    applicationLanguageChanged(applicationLanguage: FiApplicationLanguageType) {
        this.postMessage('fic.ApplicationLanguageChanged', { applicationLanguage: applicationLanguage });
    }

    showKeyboard() {
        this.postMessage('fic.ShowKeyboard');
    }

    openChecklistViewer(checklistId: number, checklistName: string) {
        this.postMessage('fic.OpenChecklistViewer', { checklistId: checklistId, checklistName: checklistName });
    }

    openFormViewer(formId: number, formName: string) {
        this.postMessage('fic.OpenFormViewer', { formId: formId, formName: formName });
    }

    onMarkNewsFeedAsVisited(item: IObjectDto) {
        this.postMessage('fic.OnMarkNewsFeedAsVisited', { ObjectId: item.ObjectId, ObjectType: item.ObjectType });
    }

    setMobileAppMode(url: string) {
        // https://chainformation.atlassian.net/browse/FI-2665
        this._mobileAppMode = true;
        const token = this.userDataService.getToken();
        localStorage.setItem(this.mobileAppTokenKey, token);
    }

    checkOpenInternalLink($event: MouseEvent) {
        const linkElement: HTMLAnchorElement = <any>eventFindInPath($event, 'a');
        if (linkElement) {
            const href = linkElement.getAttribute('href');
            const stateData = this.fiStateService.getStateByUrl(href);
            if (stateData) {
                this.fiStateService.go(stateData.stateName, stateData.stateParams);
                return true;
            }
        }
        return false;
    }
}
